module.exports = __webpack_public_path__ + "img/h10-duque-de-loule-boutique-hotel.0ddf5751.jpg";